<template>
  <div>
    <yx-auto-complete
      :width="width"
      :api="api.getPriceitemList"
      :placeholder="placeholder"
      :keys="{ searchKey: false, nameKey: 'priceItemName' }"
      :query-params="{ curriculumId: curriculumid || '' }"
      :disabled="disabled"
      :no-page="true"
      :immediate="true"
      @select="(arg) => $emit('select', arg)"
      @clear="() => $emit('clear')"
      ref="yxRef"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    width: {
      type: String,
      default: '320px',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    // 课程id
    curriculumid: [Number, String],
    disabled: Boolean,
  },
  setup() {
    const yxRef = ref(null);
    return {
      yxRef,
      clearField() {
        yxRef.value.clearField();
      },
    };
  },
});
</script>
